import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import { useMutation, useSubscription } from "@apollo/client";

import Header from "./Layout/Header";
import Footer from "./Layout/Footer";
import {
  CART_UPDATE_SUBSCRIPTION,
  FIND_OR_CREATE_CART,
} from "./Cart/cart.queries";
import { cartVar } from "./apollo/cache";
import { useEffect, useState } from "react";
import { IntlProvider } from "react-intl";
import { SUPPORTED_LOCALES, TRANSLATIONS } from "./lang/translations";
import CartNotification from "./shared/CartNotification";

import { PostHogProvider } from 'posthog-js/react'

// Root template.
function App() {
  const [locale] = useState<SUPPORTED_LOCALES>('en');

  const cartId = (() => { try { return localStorage.getItem("dcid"); } catch { return null; } })();

  const [findOrCreateCart, { error: findOrCreateCartError, data }] =
    useMutation(FIND_OR_CREATE_CART, { variables: { cartId } });

  useEffect(() => {
    findOrCreateCart();
  }, [findOrCreateCart]);

  if (data) {
    const { findOrCreateCart: cart } = data;
    if (cart) {
      try {
        localStorage.setItem("dcid", cart._id);
      } catch {
        // Safari private mode: localStorage unavailable, continue in-memory
      }
      cartVar(cart);
    }
  }

  if (findOrCreateCartError) {
    // TODO - show error./handle.
  }

  const { data: update } = useSubscription(CART_UPDATE_SUBSCRIPTION, {
    variables: { cartId },
  });

  // Update the local cache when we receive subscriptions.
  if (update?.cartUpdated?.cart) {
    cartVar(update.cartUpdated.cart);
  }

  // TODO: subscribe to general errors?

  const messages = TRANSLATIONS[locale];

  return (
    <div className="App">
      <PostHogProvider apiKey={process.env.REACT_APP_VITE_PUBLIC_POSTHOG_KEY || ''} options={{
        api_host: process.env.REACT_APP_VITE_PUBLIC_POSTHOG_HOST || '',
        defaults: '2025-05-24',
      }}>
        <IntlProvider locale={navigator.language} messages={messages} defaultLocale="en-US">
          <Header />
          <Box component="div" sx={{ position: "relative", minHeight: "70vh", width: "100%" }}>
            <Outlet />
          </Box>
          <CartNotification update={update} />
          <Footer />
        </IntlProvider>
      </PostHogProvider>
    </div>
  );
}


export default App;
